import { gsap } from "gsap";
import { getKeyboardFocusableElements } from '../utils';

class AccordionItem {
	constructor(el) {

		// DOM elements
		this.el = el;
		this.collapse = this.el.querySelector('[data-accordion-item-collapse]');
		this.toggle = this.el.querySelector('[data-accordion-item-toggle]');
		this.getKeyboardFocusableElements = getKeyboardFocusableElements(this.collapse);

		// Status
		this.detailsOpen = false;
		this.animating = false;

		// Event listeners
		this.toggle.addEventListener('click', this.toggleDetails.bind(this));

		// Set initial tabindex
		this.getKeyboardFocusableElements.forEach(element => (element.tabIndex = -1));
	}

	/**
	 * @param {boolean} value
	 */
	set open(value) {
		this.detailsOpen = value;

		if (value) {
			this.el.classList.add('is-open');
		} else {
			this.el.classList.remove('is-open');
		}

        if (this.detailsOpen) {
            this.toggle.setAttribute('aria-expanded', true);
			this.collapse.setAttribute('aria-hidden', false);
        } else {
            this.toggle.setAttribute('aria-expanded', false);
			this.collapse.setAttribute('aria-hidden', true);
        }
	}

	set opening(value) {
		if (value) {
			this.el.classList.add('is-opening');
		} else {
			this.el.classList.remove('is-opening');
		}
	}

	get open() {
		return this.detailsOpen;
	}

	toggleDetails() {
		if (this.animating) {
			return;
		}

		if (this.open) {
			this.closeDetails();
		} else {
			this.openDetails();
		}
	}

	openDetails() {
        const tl = gsap.timeline({
            onStart: () => {
                this.animating = true;
		        this.opening = true;

            },
            onComplete: () => {
                this.animating = false;
                this.open = true;
            }
        });

        tl.fromTo(this.collapse, {
            height: 0
        }, {
            height: this.collapse.scrollHeight,
            ease: 'power2.inOut',
            duration: 0.4,
        });

        tl.fromTo(this.collapse, {
            opacity: 0
        }, {
            opacity: 1,
            ease: 'none',
            duration: 0.4,
        });

		this.getKeyboardFocusableElements.forEach(element => element.removeAttribute('tabindex'));
	}

	closeDetails() {
        const tl = gsap.timeline({
            onStart: () => {
                this.animating = true;
		        this.opening = false;
            },
            onComplete: () => {
                this.animating = false;
			    this.open = false;
            }
        });

        tl.fromTo(this.collapse, {
            opacity: 1
        }, {
            opacity: 0,
            ease: 'none',
            duration: 0.2,
        });

        tl.fromTo(this.collapse, {
            height: this.collapse.scrollHeight
        }, {
            height: 0,
            ease: 'power2.inOut',
            duration: 0.4,
        });

		this.getKeyboardFocusableElements.forEach(element => (element.tabIndex = -1));
	}
}

export default class Accordion {
	constructor(el) {
		this.el = el;
		const accordionsItems = el.querySelectorAll('[data-accordion-item]');

		this.items = accordionsItems.forEach(item => {
			new AccordionItem(item);
		});
	}
}